import { useInstantSearch } from 'react-instantsearch';

import { Container, Text } from 'components/@tedui';

import { ClearRefinements, CurrentRefinements } from '.';

export function RefinementBar(): React.ReactNode {
  const { results } = useInstantSearch();

  return (
    <Container className="md-tui:relative">
      <section id="active-search-meta" className="relative">
        <div className="flex flex-col gap-1 md-tui:flex-row md-tui:items-center md-tui:gap-4">
          <ClearRefinements />
          <Text tag="h4" variant="header3" isBold>
            {results.nbHits} results about...
          </Text>
        </div>

        <CurrentRefinements />
      </section>
    </Container>
  );
}
